<article class="booking-policy-step-card">
    <header class="booking-policy-step-header vstack gap-1">
        <h2
            #heading
            class="booking-step-heading h4 fw-semibold m-0"
            tabindex="-1"
        >
            Terms and Conditions
        </h2>
    </header>

    <div class="booking-policy-step-content vstack gap-3">
        <div
            #policyContent
            data-testid="booking-policy-content"
        >
            @for (policy of policies(); track $index) {
                <section class="booking-policy-content-section quill-flush">
                    <quill-view
                        format="html"
                        theme="bubble"
                        [content]="policy"
                        [sanitize]="true"
                    />
                </section>
            }
        </div>

        <div
            #policyActions
            class="booking-policy-step-actions"
        >
            <button
                type="button"
                class="btn btn-primary w-100"
                data-testid="accept-booking-policy"
                [disabled]="!policyRead()"
                (click)="accepted.emit()"
            >
                {{ policyRead() ? 'Accept & Continue' : 'Scroll to Read' }}
            </button>
        </div>
    </div>
</article>
